export const removeStyle = (value) => {
  const regex = /(style="[^">]+")+/gi;
  return value.replace(regex, "");
};

export const removeHtmlTags = (value) => {
  const regex = /(<([^>]+)>)|&nbsp|;/gi;
  return (value || "").replace(regex, "");
};
